import React, { useRef } from 'react';
import './style.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const CustomCheckbox = ({
  checked = false,
  value = 'true',
  onChange = () => {},
  className = '',
  label = null,
  id = undefined,
  name = undefined,
  onFocus = () => {},
  onBlur = () => {},
}) => {
  const idRef = useRef(id || String(Math.round(Math.random() * 10000)));

  const handleChange = (e) => {
    onChange(e.target.checked);
  };

  return (
    <div className={clsx('custom-checkbox', className)}>
      <div className="custom-checkbox-input-wrapper">
        <input
          id={idRef.current}
          name={name}
          onFocus={onFocus}
          onBlur={onBlur}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          value={value}
          className="custom-checkbox-input"
        />
        <div
          className={clsx('custom-checkbox-control', checked && 'custom-checkbox-control-active')}
        >
          {checked && <Check />}
        </div>
      </div>
      {label && (
        <label htmlFor={idRef.current} className="custom-checkbox-label">
          {label}
        </label>
      )}
    </div>
  );
};

const Check = () => (
  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.6342L5.32597 6.53515V6.53515L3.76797 8.16894L2.20996 6.53515L2.21861 6.52609L0 4.17446L1.55842 2.54067L3.77662 4.89271L8.44199 0L10 1.6342Z"
      fill="white"
    />
  </svg>
);

CustomCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
};

export default CustomCheckbox;
